import common from "./common.json";
import auth from "./auth.json";
import dashboard from "./dashboard.json";
import clientHeader from "./clientHeader.json";
import clientDetails from "./clientDetails.json";
import rescheduling from "./rescheduling.json";

export default {
  common,
  auth,
  dashboard,
  clientHeader,
  clientDetails,
  rescheduling,
};
